var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "81.04%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E8E8E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "empty-c",
    d: "M60,120 C93.137085,120 120,93.137085 120,60 C120,26.862915 95.137085,62 62,62 C28.862915,62 0,26.862915 0,60 C0,93.137085 26.862915,120 60,120 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "empty-b",
    width: "103.3%",
    height: "105.4%",
    x: "-1.7%",
    y: "-2.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.866666667   0 0 0 0 0.866666667   0 0 0 0 0.866666667  0 0 0 0.1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "url(#empty-a)",
    d: "M104,12.5 C104.966498,12.5 105.841498,12.8917508 106.474874,13.5251263 C107.108249,14.1585017 107.5,15.0335017 107.5,16.000007 L107.5,16.000007 L107.501116,95.8370847 C96.6396312,110.210916 79.4046403,119.5 60,119.5 C40.59625,119.5 23.3619502,110.211769 12.5003789,95.839063 L12.5003789,95.839063 L12.5,16 C12.5,15.0335017 12.8917508,14.1585017 13.5251263,13.5251263 C14.1585017,12.8917508 15.0335017,12.5 16,12.5 L16,12.5 Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DDD",
    transform: "translate(16.5 16.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 15,
    fill: "#337AB7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M60,51 C60.8284271,51 61.5,51.6715729 61.5,52.5 L61.5,58.499 L67.5,58.5 C68.3284271,58.5 69,59.1715729 69,60 C69,60.8284271 68.3284271,61.5 67.5,61.5 L61.5,61.499 L61.5,67.5 C61.5,68.3284271 60.8284271,69 60,69 C59.1715729,69 58.5,68.3284271 58.5,67.5 L58.5,61.499 L52.5,61.5 C51.6715729,61.5 51,60.8284271 51,60 C51,59.1715729 51.6715729,58.5 52.5,58.5 L58.5,58.499 L58.5,52.5 C58.5,51.6715729 59.1715729,51 60,51 Z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#empty-b)",
    xlinkHref: "#empty-c"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.e84d28216c1a8d0479429576b1368032.svg";
export { ForwardRef as ReactComponent };